import { BaseAPI } from '@services/api';

class API extends BaseAPI {
  constructor() {
    super('nnc/cause');
  }
}

export default new API();
